import { createSelector } from 'reselect';

const selectTenantFunctions = (state: any) => state.tenantFunctions;


export const selectTenantFunctionCurrentItem = createSelector([selectTenantFunctions], (tenantFunctions) => tenantFunctions.current);

export const selectTenantFunctionsListItems = createSelector([selectTenantFunctions], (tenantFunctions) => tenantFunctions.list);

export const selectTenantFunctionItemById = (itemId: any) =>
    createSelector(selectTenantFunctionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTenantFunctionQueryItems = createSelector([selectTenantFunctions], (tenantFunctions) => tenantFunctions.query);

export const selectTenantFunctionCreatedItem = createSelector([selectTenantFunctions], (tenantFunctions) => tenantFunctions.create);

export const selectTenantFunctionUpdatedItem = createSelector([selectTenantFunctions], (tenantFunctions) => tenantFunctions.update);

export const selectTenantFunctionReadItem = createSelector([selectTenantFunctions], (tenantFunctions) => tenantFunctions.read);

export const selectTenantFunctionDeletedItem = createSelector([selectTenantFunctions], (tenantFunctions) => tenantFunctions.delete);

export const selectTenantFunctionSearchedItems = createSelector([selectTenantFunctions], (tenantFunctions) => tenantFunctions.search);

export const selectTenantFunctionItemsCount = createSelector([selectTenantFunctions], (tenantFunctions) => tenantFunctions.count);

export const selectTenantFunctionItemsFilter = createSelector([selectTenantFunctions], (tenantFunctions) => tenantFunctions.filter);